import Vue from "vue";
import { EventEmitter } from "events";

class AccountService extends EventEmitter {
  constructor() {
    super();
  }

  /**
   * Method to get all report types: POST
   */
  updateAccount(accountId, data) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .put(`/Account/${accountId}`, data)
        .then(response => {
          console.log("updateAccount then:", response);
          resolve(response.data);
        })
        .catch(error => {
          console.log("updateAccount catch: ", error);
          resolve(error.response);
        });
    });
  }
}

const accountService = new AccountService();

accountService.setMaxListeners(5);

export default accountService;
